import {
    Directive,
    ElementRef,
    Output,
    EventEmitter,
    HostListener
} from '@angular/core';
// Attribute directive to detect clicks outside the component and take appropriate action
// Example: Close dropdown menu when User clicks outside of Dropdown Area
@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
    constructor(private elementRef: ElementRef) {}

    @Output()
    public readonly clickOutside = new EventEmitter();

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement: Element) {
        const clickedInside =
            this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(null);
        }
    }
}
